import React from "react";
import { ClockIcon, LayersIcon, RouteIcon, BoxIcon } from "lucide-react";
import { Reveal } from "./ui/Reveal";
import { problems } from "../data/content";
const ICONS = {
  layers: LayersIcon,
  help: BoxIcon,
  route: RouteIcon,
  clock: ClockIcon
};
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-white text-charcoal" data-id="element-141" data-mp="2vpz9wmonbxe8">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-142" data-mp="39hw0unekw191">
        <p className="inline-block rounded bg-red-600 px-2 py-0.5 font-display text-xs font-bold uppercase tracking-widest text-white" data-id="element-143" data-mp="39g2tt701zf0i">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-2 font-anton text-2xl uppercase leading-tight sm:text-3xl" data-id="element-144" data-mp="3jeqzd6auq1nb">
          Querés aprender a fabricar muebles de melamina,{' '}
          <span className="bg-cta px-1" data-id="element-145" data-mp="1p1ixwvsdersp">pero no sabés por dónde empezar.</span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-charcoal/80" data-id="element-146" data-mp="1k37naiu94d9f">
          Si estás comenzando desde cero o querés aprender a hacer muebles para
          tu casa y ofrecer trabajos por encargo, probablemente conozcas alguna
          de estas situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-147" data-mp="sdtf3fi5vfzc">
          {problems.map((problem, i) => {
          const Icon = ICONS[problem.icon];
          return <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-lg border-l-4 border-red-600 bg-red-50 p-2.5 text-left" data-id="element-148" data-mp="x5biea7npsnh" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-red-600" data-id="element-149" data-mp="172fwrnv9gjtq">
                  <Icon size={15} className="text-white" data-id="element-150" data-mp="1c1izh1nrqdyj" />
                </span>
                <div data-id="element-151" data-mp="1g346w7hja01c">
                  <h3 className="font-display text-sm font-extrabold uppercase leading-tight" data-id="element-152" data-mp="1g3nofn39umeu">
                    {problem.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-charcoal/80 sm:text-sm" data-id="element-153" data-mp="3dvi97il8sn94">
                    {problem.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}